// extracted by mini-css-extract-plugin
var _1 = "ProgressSubsection__bonusIcon--CovqX";
var _2 = "ProgressSubsection__celestial--Mp5up";
var _3 = "ProgressSubsection__celestialImage--aVovL";
var _4 = "ProgressSubsection__hIcon--shRTD ProgressSubsection__hItem--rk68M";
var _5 = "ProgressSubsection__hItem--rk68M";
var _6 = "ProgressSubsection__hStar--UsoVx";
var _7 = "ProgressSubsection__hStarContainer--iKoDU ProgressSubsection__hItem--rk68M";
var _8 = "ProgressSubsection__history--jsy1X ProgressSection__history--dk67T ProgressSection__progress--lypNy";
var _9 = "ProgressSubsection__lock--mc6El";
var _a = "ProgressSubsection__main--FzB2O fontSize__profileSmallPlus--_oZpO";
var _b = "ProgressSubsection__star--q5Xca";
var _c = "ProgressSubsection__starImage--Bstu9";
var _d = "ProgressSubsection__stars--nuT_D ProgressSection__star--tMbb1 ProgressSection__progress--lypNy";
var _e = "ProgressSubsection__time--FocBv ProgressSection__time--hbQuT ProgressSection__progress--lypNy";
var _f = "ProgressSubsection__timeText--lxVNm";
var _10 = "ProgressSubsection__title--kEDma";
var _11 = "ProgressSubsection__titleLinkGrade2--ZCC9M OfficeGeneral__hoverGrade2--X5YBZ";
var _12 = "ProgressSubsection__titleLinkGrade3--eCX7u OfficeGeneral__hoverGrade3--bvmS3";
var _13 = "ProgressSubsection__titleLinkGrade4--smItT OfficeGeneral__hoverGrade4--bgkre";
var _14 = "ProgressSubsection__titleLinkGrade5--kdNmi OfficeGeneral__hoverGrade5--CHnJM";
var _15 = "ProgressSubsection__trophy--yM4fu ProgressSection__trophy--aF2nt ProgressSection__progress--lypNy";
var _16 = "ProgressSubsection__trophyImage--EfvVc";
var _17 = "ProgressSubsection__xp--lJiOn ProgressSection__xp--aBygb ProgressSection__progress--lypNy";
var _18 = "ProgressSubsection__xpText--h3irh";
export { _1 as "bonusIcon", _2 as "celestial", _3 as "celestialImage", _4 as "hIcon", _5 as "hItem", _6 as "hStar", _7 as "hStarContainer", _8 as "history", _9 as "lock", _a as "main", _b as "star", _c as "starImage", _d as "stars", _e as "time", _f as "timeText", _10 as "title", _11 as "titleLinkGrade2", _12 as "titleLinkGrade3", _13 as "titleLinkGrade4", _14 as "titleLinkGrade5", _15 as "trophy", _16 as "trophyImage", _17 as "xp", _18 as "xpText" }
